import ModalContext from './modal-context';


class AlertContext extends ModalContext {}


export default AlertContext;
